import React from 'react';
import AgentApp from './agent/AgentApp';
import ErrorBoundary from './agent/ErrorBoundary';

// The agent workspace is the app. (The old document editor still exists in the
// tree — src/Entrance.jsx — but nothing routes to it any more.)
function App() {
  return <ErrorBoundary><AgentApp /></ErrorBoundary>;
}

export default App;
